import React, { useEffect, useRef, useState } from "react";
import { io } from "socket.io-client";
import Chat from "../components/Chat";
import FileShare from "../components/FileShare";

const baseUrl = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL;
const socket = io(baseUrl);

export default function Lecturer() {
  const videoRef = useRef();
  const peerConnections = useRef({});
  const streamRef = useRef();
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const startScreenShare = async () => {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
      });
      streamRef.current = stream;
      videoRef.current.srcObject = stream;

      // Новый студент просит offer
      socket.on("need-offer", async ({ studentId }) => {
        if (peerConnections.current[studentId]) {
          peerConnections.current[studentId].close();
          delete peerConnections.current[studentId];
        }
        const pc = new RTCPeerConnection({
          iceServers: [
            { urls: "stun:stun.l.google.com:19302" },
            {
              urls: "turn:openrelay.metered.ca:80",
              username: "openrelayproject",
              credential: "openrelayproject"
            }
          ]
        });
        pc.onicecandidate = (event) => {
          if (event.candidate) {
            const type = event.candidate.candidate.match(/ typ ([a-z]+)/)?.[1];
            console.log("ICE candidate:", event.candidate);
            console.log("ICE candidate type:", type, "candidate string:", event.candidate.candidate);
            socket.emit("ice-candidate", {
              candidate: event.candidate,
              to: studentId,
            });
          }
        };
        stream.getTracks().forEach((track) => pc.addTrack(track, stream));
        peerConnections.current[studentId] = pc;
        const offer = await pc.createOffer();
        await pc.setLocalDescription(offer);
        const offerWithFrom = { ...offer, from: socket.id };
        socket.emit("offer-to", { offer: offerWithFrom, studentId });
        socket.on("answer", async ({ answer, from }) => {
          if (from === studentId && answer) {
            await pc.setRemoteDescription(new RTCSessionDescription(answer));
          }
        });
        socket.on("ice-candidate", async ({ candidate, from }) => {
          if (from === studentId) {
            try {
              await pc.addIceCandidate(new RTCIceCandidate(candidate));
            } catch (err) {
              console.error("Ошибка добавления ICE:", err);
            }
          }
        });
        pc.onconnectionstatechange = () => {
          console.log(
            `Lecturer connection state for ${studentId}:`,
            pc.connectionState
          );
          if (
            pc.connectionState === "disconnected" ||
            pc.connectionState === "failed" ||
            pc.connectionState === "closed"
          ) {
            pc.close();
            delete peerConnections.current[studentId];
          }
        };
      });
    };
    startScreenShare();
    return () => {
      Object.values(peerConnections.current).forEach((pc) => pc.close());
      peerConnections.current = {};
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f9f9f9" }}>
      <h1
        style={{
          textAlign: "center",
          fontFamily: "Arial",
          margin: 0,
          padding: 24,
          fontWeight: 700,
          fontSize: 32,
          color: "#222",
        }}
      >
        Лектор
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 32,
          maxWidth: 1400,
          margin: "0 auto",
          padding: "0 24px",
        }}
      >
        <div
          style={{
            flex: 2,
            background: "#000",
            borderRadius: 12,
            boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 480,
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              width: "100%",
              height: "auto",
              maxHeight: 600,
              backgroundColor: "black",
              borderRadius: 0,
            }}
          />
        </div>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 24,
            maxHeight: 600,
            minWidth: 350,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 2px 16px rgba(0,0,0,0.10)",
            padding: 20,
            overflowY: "auto",
          }}
        >
          <Chat userName={userName} setUserName={setUserName} />
          <FileShare isLecturer={true} />
        </div>
      </div>
    </div>
  );
}
